import { useCreate } from '@refinedev/core';

import {
  type IAccountActivationTokenCheckerPayload,
  type IAccountPayload,
} from '../model/account';

export const useAccountService = () => {
  const { mutate, isLoading } = useCreate();

  async function activate(values: IAccountPayload): Promise<any> {
    return new Promise((resolve, reject) => {
      mutate({
        resource: 'auth/customer-portal/account-activation',
        values,
        dataProviderName: 'auth',
        meta: {
          headers: { 'x-app-id': 'customer_portal' },
        },
      }, {
        onSuccess: (response) => resolve(response),
        onError: (error) => reject(error),
      });
    });
  }

  async function activationTokenChecker(
    values: IAccountActivationTokenCheckerPayload,
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      mutate({
        resource: 'auth/customer-portal/account-activation/token-checker',
        values,
        dataProviderName: 'auth',
      }, {
        onSuccess: (response) => resolve(response),
        onError: (error) => reject(error),
      });
    });
  }

  return {
    activate,
    activationTokenChecker,
    isLoading,
  };
};

export default useAccountService;
